<p-dialog
  (visibleChange)="handleVisibleChange($event)"
  [draggable]="false"
  [modal]="true"
  [style]="{ width: '100rem', maxWidth: '96vw' }"
  [visible]="visible()"
  header="Wybór kosmetyków">
  <app-table
    (selectionChangeEvent)="handleSelectionChangeEvent($event)"
    [config]="config"
    [customCellTemplateRef]="customCellTemplateRef" />

  <ng-template
    #customCellTemplateRef
    let-column="column"
    let-model="model">
    @switch (column.key) {
      @case (getColumnKey('featuredFileUrl')) {
        @if (isNotNil(model.featuredFileUrl)) {
          <app-image-thumbnail size="sm">
            <img
              [ngSrc]="model.featuredFileUrl"
              [fill]="true"
              [alt]="model.featuredFileAlt"
              class="object-contain" />
          </app-image-thumbnail>
        } @else {
          <app-image-thumbnail-unsupported size="sm" />
        }
      }

      @default {
        <app-no-data />
      }
    }
  </ng-template>

  <div class="modal-footer mt-4 flex justify-end gap-4 sticky bottom-0 bg-white">
    <p-button
      (onClick)="handleSubmitClick()"
      [disabled]="selectedIds.length === 0"
      appPrimengButton
      label="Dodaj wybrane kosmetyki"
      severity="primary" />

    <p-button
      (onClick)="cancelEvent.emit()"
      appPrimengButton
      label="Anuluj"
      severity="secondary" />
  </div>
</p-dialog>
